import SearchTalent from "../../components/employeer/search-talent";

const SearchEmployeerPage = () => {
  return <SearchTalent />;
};

export default SearchEmployeerPage;
